import React from "react";
import { Check, ChevronRight, Hospital } from "lucide-react";

import Button from "../Button";
import Card from "../Card/Card";

import { POST_MESSAGE_EVENTS } from "src/constants/common";
import environment from "src/constants/environment";
import sendMessageToParent from "src/helpers/parentMessageHandler";
import supportPrograms from "src/data/app/programs";

interface ProgramDetailsCardProps {
  supportProgramKey: string;
}

const ProgramDetailsCard: React.FC<ProgramDetailsCardProps> = ({
  supportProgramKey,
}) => {
  const config =
    supportPrograms[supportProgramKey as keyof typeof supportPrograms];

  const benefits = config?.website?.benefits;

  const handleViewDetailsClick = () => {
    const data = {
      title: "Program Details",
      url: `${environment.DOMAIN_URL}/programs/${supportProgramKey}?mode=view_only`,
    };
    sendMessageToParent(POST_MESSAGE_EVENTS.NAVIGATE_TO_WEBVIEW, data);
  };

  return (
    <div className="mx-4">
      <Card
        title={config?.support_program_name}
        icon={<Hospital className="w-4 h-4" />}
        description="Care program"
      >
        <div className="w-full">
          <ul className="flex flex-col gap-1">
            {benefits?.benefits?.map((benefit: any, index: number) => (
              <li className="flex flex-row items-center gap-2" key={index}>
                <Check className="w-4 h-4 text-green-500" />
                <span className="text-xs font-light text-gray-500">
                  {benefit?.title}
                </span>
              </li>
            ))}
          </ul>
          <div className="w-full mt-4">
            <Button
              variant="contained"
              rounded="full"
              fullWidth={true}
              onClick={handleViewDetailsClick}
            >
              <span>Program Details</span>
              <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ProgramDetailsCard;
